import axios from 'axios'
import { baseApiUrl, uploaderUrl } from '../config'
import { showToast } from './toast'

const axiosInstance = axios.create({
    validateStatus: status => {
      return status >= 200 && status <= 503;
    },
  });

const ThrowAPIError = (res) => {
    if(res.status >= 400 && res.status <= 500) {
        throw 'API Error'
    } 
}
  
function crudService (baseUrl) {
    const url = baseApiUrl + baseUrl
    const uploadUrl = uploaderUrl + baseUrl

    axiosInstance.defaults.headers.common['Authorization'] = localStorage.getItem('dtp_token') || ''

    return {
        createWithResultAndToast: async function (payload) {
            const response = await axiosInstance.post(url, payload)
            showToast(response)
            return {
                ok: response.status === 200,
                data: response.data.data
            }
        },
        get: async function () {
            const { data } = await axiosInstance.get(url)
            return data.data
        },
        getWithQuery: async function(query) {
            const response = await axiosInstance.get(url, query)
            showToast(response, true)
            return response.data.data
        },
        getWithParams: async function (params) {
            const { data } = await axiosInstance.get(`${url}/${params}`)
            return data.data
        },
        create: async function (payload) {
            const response = await axiosInstance.post(url, payload)
            showToast(response)
            ThrowAPIError(response)
        },
        createWithResult: async function (payload) {
            const { data } = await axiosInstance.post(url, payload)
            return data.data
        },
        update: async function (payload, params) {
            const response = await axiosInstance.put(`${url}/${params}`, payload)
            showToast(response)
            ThrowAPIError(response)
            return response.data.data
        },
        delete: async function (params) {
            const response = await axiosInstance.delete(`${url}/${params}`)
            showToast(response)
            ThrowAPIError(response)
        },
        upload: async function (payload) {
            const { data } = await axiosInstance.post(uploadUrl, payload)
            return data.data
        },
        removeAsset: async function (payload) {
            await axiosInstance.post(url, payload)
        },
        getReport(v) {
            return axiosInstance.post(`${url}/report`, v, {
              responseType: 'arraybuffer'
            });
        },
        getFileWithQuery: async function(query) {
            const { data } = await axiosInstance.get(url, {
                ...query,
                responseType: 'arraybuffer'
            })
            return data
        },
    }  
}

export default crudService